export type Solution = {
  name: string;
  to: string;
  icon: string;
  description: string;
};

export const solutions: Solution[] = [
  {
    name: 'Architects',
    to: '/solutions/architects',
    icon: 'architecture',
    description: 'The Place to Store, Refine, and Present All Your Designs',
  },
  {
    name: 'Developers',
    to: '/solutions/developers',
    icon: 'domain_add',
    description: 'Land & Property Developers, see the Whole Picture - From Plot to Portfolio',
  },
  {
    name: 'Surveyors',
    to: '/solutions/surveyors',
    icon: 'straighten',
    description: 'Built for Precision: Deliver, Share, and Manage Every Survey with Ease',
  },
  {
    name: 'Engineers',
    to: '/solutions/engineers',
    icon: 'precision_manufacturing',
    description: 'Stay in Control: Visualise, Validate, and Collaborate on Technical Data',
  },
  {
    name: 'Asset Owners',
    to: '/solutions/asset-owners',
    icon: 'business_center',
    description: 'Know Your Estate: Centralise Data, Track Changes, and Protect Value',
  },
  {
    name: 'Consultants',
    to: '/solutions/consultants',
    icon: 'lightbulb',
    description: 'Win Work, Add Value: Present Insights and Share Recommendations Seamlessly',
  },
  {
    name: 'Contractors',
    to: '/solutions/contractors',
    icon: 'construction',
    description: 'Keep the Site Moving: Access, Update, and Deliver Files Without the Fuss',
  },
] as const;
